export { GlobalStylesProvider, PLATFORM_COOKIE, REBRAND_COOKIE, useTheme, } from './GlobalStylesProvider';
//# sourceMappingURL=index.js.map
// @zapier/global-styles-provider@0.6.0 (2376bbd83)
